// extracted by mini-css-extract-plugin
export default {"carousel_cont":"carousel_carousel_cont__vacvi"};